import { useEffect } from 'react';

export const useScrollEffect = () => {
  useEffect(() => {
    const header = document.getElementById("header");
    const body = document.body;

    function updateScrolled() {
      const scrolled = window.scrollY > 100;
      header?.classList.toggle("header-scrolled", scrolled);
      body.classList.toggle("scrolled", scrolled);
    }

    updateScrolled();
    const t1 = window.setTimeout(updateScrolled, 50);
    const t2 = window.setTimeout(updateScrolled, 250);

    window.addEventListener("scroll", updateScrolled, { passive: true });
    window.addEventListener("hashchange", updateScrolled);

    return () => {
      window.clearTimeout(t1);
      window.clearTimeout(t2);
      window.removeEventListener("scroll", updateScrolled);
      window.removeEventListener("hashchange", updateScrolled);
    };
  }, []);
};

export const usePreloader = () => {
  useEffect(() => {
    const preloader = document.getElementById("preloader");
    if (preloader) preloader.remove();
  }, []);
};
